<template lang="pug">

  .SampleDetails#SampleDetails

    ScrollIndicator(
      orientation="vertical"
      :progress="swiperProgress"
    )

    .SampleDetails_wrapper(ref="wrapper")

      template(v-for="(p, key) in items", v-if="items")
        .SampleDetails_item(v-if="hasProperty(p)")
          p.SampleDetails_item_title {{ $t('sample.details.' + key) }}
          ul.SampleDetails_item_list
            li.SampleDetails_item_list_item(v-for="(o, key) in p", v-if="o")
              label {{ o.label }}
              p(v-if="key === 'colors'")
                span.SampleDetails_item_list_itemColorBullet(v-for="(c, index) in getFormattedColors(o.value)" :style="'background-color: ' + c +''")
              p(v-else) {{ getFormattedValue(o.value ) }}

</template>

<script>

import ScrollIndicator from '@/components/ScrollIndicator'

export default {
  components: {
    ScrollIndicator
  },
  props: ['items'],
  data () {
    return {
      scrollProgress: false,
      sectionIsVisible: true,
      scrollPosition: 0,
      lastY: 0,
      swiperProgress: 0
    }
  },
  methods: {
    onWheel (e) {
      const st = document.body.querySelector('.MainContainer').scrollTop
      const cscHeight = document.body.querySelector('.CoverSectionContent').offsetHeight

      if (st > 50) {
        document.body.querySelector('.SampleCover').classList.add('is-disabled')
      } else {
        document.body.querySelector('.SampleCover').classList.remove('is-disabled')
      }

      if (cscHeight > (window.innerHeight + st)) {
        document.body.querySelector('.SampleCover').classList.remove('is-sticky')
      } else {
        document.body.querySelector('.SampleCover').classList.add('is-sticky')
      }
    },
    getFormattedColors (value) {
      if (!Array.isArray(value)) return [value]
      return value
    },
    getFormattedValue (value) {
      if (!value) return ''
      else if (Array.isArray(value)) return value.join(', ')
      else if (value.from && value.to) return value.from + ' / ' + value.to
      else if (value.lat && value.lng) return value.lat + ' / ' + value.lng
      return value
    },
    hasProperty (p) {
      for (var i in p) { if (p[i]) return true }
      return false
    },
    touchStart () {
      this.lastY = null
    }
  },
  beforeDestroy () {
    document.body.querySelector('.MainContainer').removeEventListener('scroll', this.onWheel)
  },
  mounted () {
    document.body.querySelector('.MainContainer').addEventListener('scroll', this.onWheel)
  }
}

</script>

<style lang="stylus" scoped>
.SampleDetails

  padding-top 80vh
  position relative
  z-index 9
  overflow hidden
  box-sizing border-box
  right 50px
  color white
  height auto
  width 100%
  overflow-y hidden
  pointer-events none

  @media screen and (max-width: 1023px)
    padding-top 100vh

  @media $mq_m_only

    right unset

  @media $mq_s_only

    right unset

  .ScrollIndicator.is-vertical
    top 50vh
    right 0

    @media $mq_s_only
      right 20px

    @media $mq_m_only
      right 80px

  &_wrapper

    width 100%
    padding-top 0vh
    margin-left auto
    margin-right 0px
    max-width 350px

    @media $mq_l_only

      max-width 250px

    @media $mq_s_only

      padding 0vh 20px 80px 20px
      max-width unset
      box-sizing border-box
      width 100%

    @media $mq_m_only

      padding 0vh 80px 80px 80px
      max-width unset
      box-sizing border-box
      width 100%

  &_item

    margin-bottom 90px
    font-size 14px

    &_title

      margin-bottom 20px
      font-size 14px
      letter-spacing 4.4px
      text-transform uppercase

    &_list

      list-style none
      margin 0px
      padding 0px

      &_item

        padding 15px 0px
        cursor auto
        width 100%
        border-top 1px solid rgba(255,255,255,0.3)

        label

          color gray
          letter-spacing: 0.9px;

        p

          font-size 14px
          margin 0px 0px auto auto
          text-align right

        .SampleDetails_item_list_itemColorBullet

          // position absolute
          // top 50%
          // left 37px
          display inline-block
          border 1px solid white
          // transition border-color 0.6s $ease
          // transform translateY(-50%)
          border-radius 50%
          width: 22px
          height: 22px
          margin: 0 5px

</style>
